module.exports = __webpack_public_path__ + "img/14.907216f0.jpg";